<ng-container>
    <div class="w-100" offsetBodyObserver [propertyCss]="'--top-notification-height'">
        @if (slugNotification) {
            <cms-render-lazy [slug]="slugNotification"></cms-render-lazy>
        }
    </div>
</ng-container>
